import { css } from "theme/default/css";

export const setFlexDFJCC = css`
  display: flex;
  justify-content: center;
`;
